import { createContext } from 'react';

type TFeedbackContext = {
  onClose: (value?: string) => void;
};

const FeedbackContext = createContext<TFeedbackContext | undefined>(undefined);

export { FeedbackContext };
